const styles = {
  noPaddingTop: {
    paddingTop: '0px',
  },
  noPaddingBottom: {
    paddingBottom: '0px',
  },
  paddingTop10px: {
    paddingTop: '10px',
  },
  noMargin: {
    margin: '3px',
  },
  collapse: {
    background: '#fefefe',
    color: '#38af95',
    padding: '0px',
    border: 'none',
  },
  marginDailyProgramDays: {
    marginLeft: '3em',
  },
  marginContentInsideCard: {
    margin: '1em',
  },
  marginHeader: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  styleCard: {
    border: 'none',
    marginTop: '2em',
  },
  noMarginTopBottom: {
    marginBottom: '0px',
    marginTop: '0px',
  },
  marginGridCollapse: {
    marginLeft: '3em',
    marginBottom: '0px',
  },
  noMarginTop: {
    marginTop: '0px',
  },
  marginHeader1: { marginTop: '0px', paddingTop: '10px' },
};

export default styles;
